export const CLASSIFIED_SEARCH_PATH = 'classified-search';
